<div [innerHTML]="teaserMessage | msInterpolate: { minodds: minOddsPerLeg! } | msTrust: 'html'"></div>
